// src/stockx/base/CurrencyIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var CurrencyIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25.0001 42.9C34.886 42.9 42.9001 34.8859 42.9001 25C42.9001 15.1141 34.886 7.09998 25.0001 7.09998C15.1142 7.09998 7.1001 15.1141 7.1001 25C7.1001 34.8859 15.1142 42.9 25.0001 42.9Z",
      fill: "#D4D1C7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 44C14.5 44 6 35.5 6 25C6 14.5 14.5 6 25 6C35.5 6 44 14.5 44 25C44 35.5 35.5 44 25 44ZM25 8.2C15.8 8.2 8.2 15.7 8.2 25C8.2 34.2 15.7 41.8 25 41.8C34.3 41.8 41.8 34.2 41.8 25C41.8 15.7 34.2 8.2 25 8.2Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 18C19.5 18 14.3 16.7 10.7 14.4L11.9 12.5C15.1 14.6 19.9 15.8 25 15.8C30.1 15.8 34.7999 14.6 38.0999 12.5L39.2999 14.4C35.6999 16.7 30.5 18 25 18Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.6999 37.1L10.3999 35.2C13.9999 32.8 19.2999 31.4 24.9999 31.4C30.5999 31.4 35.8999 32.8 39.4999 35.2L38.2999 37.1C35.0999 34.9 30.1999 33.7 24.9999 33.7C19.7999 33.7 14.8999 34.9 11.6999 37.1Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 44C18.7 44 13.7 35.6 13.7 25C13.7 14.4 18.7 6 25 6C31.3 6 36.2999 14.4 36.2999 25C36.2999 35.6 31.3 44 25 44ZM25 8.3C20.1 8.3 16 16 16 25.1C16 34.2 20.1 41.9 25 41.9C29.9 41.9 34 34.2 34 25.1C34 16 29.9 8.3 25 8.3Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M26.0999 7.09998H23.8999V42.9H26.0999V7.09998Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M42.9001 23.9H7.1001V26.1H42.9001V23.9Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var CurrencyIcon_default = CurrencyIcon;

export {
  CurrencyIcon_default
};
